import React from 'react';

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Matchdata } from '@/types/match';
import { formatMapName } from '@/utils/format';

import MapView from './tab-views/MapView';
import Overview from './tab-views/Overview';

interface MatchTabsProps {
  match: Matchdata;
  matchId: string;
}

const MatchTabs: React.FC<MatchTabsProps> = ({ match, matchId }) => {
  return (
    <Tabs defaultValue="overview">
      <TabsList className="mb-4 rounded-t-lg border">
        <TabsTrigger value="overview">Overview</TabsTrigger>
        {match.get5StatsMatch.get5StatsMaps.map((map) => (
          <TabsTrigger value={map.mapname} key={map.mapname}>
            {formatMapName(map.mapname)}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent value="overview">
        <Overview match={match} matchId={matchId} />
      </TabsContent>
      {match.get5StatsMatch.get5StatsMaps.map((map, index) => (
        <TabsContent value={map.mapname} key={map.mapname}>
          <MapView match={match} matchId={matchId} index={index} />
        </TabsContent>
      ))}
    </Tabs>
  );
};

export default MatchTabs;
